import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonPanel } from "../../../../../../../base/buttons/button/index.js";
const MobilePassengersFooter = (props)=>{
    const { literals , onClick  } = props;
    const { acceptLabel =''  } = literals ?? {};
    if (!acceptLabel) return null;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "PassengersFooter",
        className: "passengers-footer",
        children: /*#__PURE__*/ _jsx(ButtonPanel, {
            onClick: onClick,
            children: acceptLabel
        })
    });
};
export default MobilePassengersFooter;

//# sourceMappingURL=index.js.map